import { COLORS } from '@btime/constants'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { Title } from '../../../../../../../packages/kiti/components/presentation/Text'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import ExpandableQuestionModal from '../modal/ExpandableQuestionModal'
import FormItem from '../../../../../../../components/form/FormItem'
import GalleryInput from '../../../../../../../components/form/GalleryInput'
import Icon from '../../../../../../../packages/kiti/components/shapes/Icon'
import Link from '../../../../../../../packages/kiti/components/actions/Link'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'
import Textarea from '../../../../../../../components/form/Textarea'

const InfoSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChange } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()
  const [openExplandableModal, setOpenExpandableModal] = useState(false)

  const { randomIdAfterUndo } = useChecklistFormActions()

  return (
    <>
      <Title size="h6" color={COLORS.dark4}>
        {t('questionInfo')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />
      <FormItem
        key={randomIdAfterUndo}
        label={t('description')}
        field="description"
        form={selectedQuestion}
        right={
          <Link onClick={() => setOpenExpandableModal(true)}>
            <Icon name="BsArrowsAngleExpand" color={COLORS.dark3} size="0.6rem" />
          </Link>
        }
      >
        <Textarea
          key={selectedQuestion.reference}
          disableRemount={true}
          limit={12000}
          rows={2}
          value={selectedQuestion.description}
          onBlur={() => null}
          onStopTyping={handleSelectedQuestionChange('description')}
          useMarkdown={true}
        />
      </FormItem>

      <FormItem label={t('fileOrImage')} field="documents">
        <GalleryInput
          colWidth="25%"
          thumbHeight="4rem"
          value={selectedQuestion.documents}
          onChange={handleSelectedQuestionChange('documents')}
          buttonLabel={t('add')}
          buttonHeight="4rem"
          gap={0.3}
        />
      </FormItem>

      <ExpandableQuestionModal
        open={openExplandableModal}
        onClose={() => setOpenExpandableModal(false)}
        field="description"
        label={t('description')}
      />
    </>
  )
}

export default InfoSection
